import './bootstrap';
import { createApp } from 'vue';
import SearchComponent from './components/SearchComponent.vue';
import DataIngestionUpload from './components/DataIngestionUpload.vue';
import FarmDataPreview from './components/previews/FarmDataPreview.vue';
import WoolLinePreview from './components/previews/WoolLinePreview.vue';
import TestingPreview from './components/previews/TestingPreview.vue';
import AuctionPreview from './components/previews/AuctionPreview.vue';
import ExportPreview from './components/ExportPreview.vue';
import FactoryPreview from './components/FactoryPreview.vue';
import BrandPreview from './components/BrandPreview.vue';
import DataSourcesPage from './pages/DataSourcesPage.vue';
import AutomationsPage from './pages/AutomationsPage.vue';
import ConnectorDetailPage from './pages/ConnectorDetailPage.vue';
import InsightsPage from './pages/InsightsPage.vue';
import DomainGraphPage from './pages/DomainGraphPage.vue';
import AIInsightsModal from './components/AIInsightsModal.vue';
import CommandPalette from './components/CommandPalette.vue';
import { supabase } from './supabase.js';
import axios from 'axios';

// Import Vue Toastification
import { createToastInterface } from 'vue-toastification';
import 'vue-toastification/dist/index.css';

// Create Vue app
const app = createApp({});

// Make Supabase available to all components
app.config.globalProperties.$supabase = supabase;

// Configure axios with base URL and CSRF token
// Use the current window location's origin instead of hardcoded IP
axios.defaults.baseURL = window.location.origin;
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
axios.defaults.withCredentials = false; // Set to false to avoid CORS issues

// Get CSRF token from meta tag
const token = document.head.querySelector('meta[name="csrf-token"]');
if (token) {
  axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
}

// Make axios available to all components
app.config.globalProperties.$axios = axios;

// Configure Toast options
const toastOptions = {
  position: 'top-right',
  timeout: 5000,
  closeOnClick: true,
  pauseOnFocusLoss: true,
  pauseOnHover: true,
  draggable: true,
  draggablePercent: 0.6,
  showCloseButtonOnHover: false,
  hideProgressBar: false,
  closeButton: 'button',
  icon: true,
  rtl: false,
  maxToasts: 20,
  newestOnTop: true
};

// Create toast interface
const toast = createToastInterface(toastOptions);

// Make toast available globally
app.config.globalProperties.$toast = toast;

// Register components
app.component('search-component', SearchComponent);
app.component('data-ingestion-upload', DataIngestionUpload);
app.component('farm-data-preview', FarmDataPreview);
app.component('wool-line-preview', WoolLinePreview);
app.component('testing-preview', TestingPreview);
app.component('auction-preview', AuctionPreview);
app.component('export-preview', ExportPreview);
app.component('factory-preview', FactoryPreview);
app.component('brand-preview', BrandPreview);
app.component('data-sources-page', DataSourcesPage);
app.component('automations-page', AutomationsPage);
app.component('connector-detail-page', ConnectorDetailPage);
app.component('insights-page', InsightsPage);
app.component('domain-graph-page', DomainGraphPage);
app.component('ai-insights-modal', AIInsightsModal);
app.component('command-palette', CommandPalette);

// Mount the app
app.mount('#app');
